import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/utils/cn';

export default function KpiCardSkeleton({ className }: { className?: string }) {
  return (
    <div className={cn('rounded-xl border bg-white p-5 shadow-sm', className)}>
      <Skeleton className="h-4 w-24 mb-3" />
      <Skeleton className="h-8 w-32 mb-2" />
      <Skeleton className="h-4 w-16" />
    </div>
  );
}
